module.exports = __webpack_public_path__ + "media/images/metronic/social/foursquare-28ea4e9951bf40c4ea8d1f65dc01d2a8.png";